/**
 * product-3col.js — Foot-Easy
 *
 * Collega i thumbnail custom (.p3c-thumb) alla media-gallery nativa di Dawn.
 * Gestisce anche:
 *   - Aggiornamento stato attivo al cambio variante
 *   - Aggiornamento stato attivo quando l'utente scorre lo slider nativo
 */

(function () {
  'use strict';

  /**
   * Aggiorna l'highlight del thumbnail custom corrispondente al mediaId dato.
   * @param {string} sectionId  - ID sezione (es. "main")
   * @param {string} mediaId    - ID media nella forma "{sectionId}-{mediaId}"
   */
  function setActiveCustomThumb(sectionId, mediaId) {
    const strip = document.getElementById('P3CThumbStrip-' + sectionId);
    if (!strip) return;

    strip.querySelectorAll('.p3c-thumb').forEach(function (btn) {
      const isTarget = btn.dataset.p3cTarget === mediaId;
      btn.classList.toggle('is-active', isTarget);
      btn.setAttribute('aria-current', isTarget ? 'true' : 'false');
    });

    // Scroll verticale: porta il thumbnail attivo in vista
    const activeBtn = strip.querySelector('.p3c-thumb.is-active');
    if (activeBtn) {
      const stripScrollTop = strip.scrollTop;
      const stripHeight = strip.clientHeight;
      const btnTop = activeBtn.offsetTop;
      const btnHeight = activeBtn.offsetHeight;

      if (btnTop < stripScrollTop || btnTop + btnHeight > stripScrollTop + stripHeight) {
        strip.scrollTo({
          top: btnTop - stripHeight / 2 + btnHeight / 2,
          behavior: 'smooth'
        });
      }
    }
  }

  /**
   * Inizializza i listener per una singola media-gallery.
   * @param {HTMLElement} gallery - elemento media-gallery
   */
  function initGallery(gallery) {
    if (!gallery || gallery._p3cInit) return;
    gallery._p3cInit = true;

    // Determina il section ID dall'ID della gallery (es. "GalleryViewer-main" → "main")
    const viewerEl = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewerEl) return;
    const sectionId = viewerEl.id.replace('GalleryViewer-', '');

    // Trova il custom strip corrispondente
    const strip = document.getElementById('P3CThumbStrip-' + sectionId);
    if (!strip) return;

    // ── 1. Click sui thumbnail custom → aggiorna media-gallery ──
    strip.querySelectorAll('.p3c-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const mediaId = btn.dataset.p3cTarget; // es. "main-123456789"

        // Chiama setActiveMedia della gallery nativa
        if (gallery.setActiveMedia) {
          gallery.setActiveMedia(mediaId, true);
        }

        // Aggiorna highlight custom
        setActiveCustomThumb(sectionId, mediaId);
      });
    });

    // ── 2. Slide changed (scroll nativo) → aggiorna custom thumbs ──
    const sliderViewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (sliderViewer) {
      sliderViewer.addEventListener('slideChanged', function (e) {
        if (e.detail && e.detail.currentElement) {
          const mediaId = e.detail.currentElement.dataset.mediaId;
          if (mediaId) setActiveCustomThumb(sectionId, mediaId);
        }
      });
    }
  }

  /**
   * Aggiorna i thumbnail custom quando cambia la variante.
   * Dawn dispatcha 'variant:change' sulla product-info o document.
   */
  function handleVariantChange(event) {
    const variant = event.detail && (event.detail.variant || event.detail);
    if (!variant) return;

    // Cerca il media della variante selezionata
    const featuredMediaId = variant.featured_media && variant.featured_media.id;
    if (!featuredMediaId) return;

    // Aggiorna tutti i strip presenti
    document.querySelectorAll('[id^="P3CThumbStrip-"]').forEach(function (strip) {
      const sectionId = strip.id.replace('P3CThumbStrip-', '');
      const mediaId = sectionId + '-' + featuredMediaId;
      setActiveCustomThumb(sectionId, mediaId);
    });
  }

  /**
   * Bootstrap: attende che media-gallery sia definito, poi inizializza.
   */
  function boot() {
    // Inizializza le gallery già presenti
    document.querySelectorAll('media-gallery').forEach(initGallery);

    // Ascolta future gallery (es. quick-add modal)
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'media-gallery') {
            initGallery(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('media-gallery').forEach(initGallery);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Listener cambio variante (Dawn usa questo evento)
    document.addEventListener('variant:change', handleVariantChange);
    // Compatibilità con alcune versioni che usano 'variantChange'
    document.addEventListener('variantChange', handleVariantChange);
  }

  // Avvia dopo il DOM (media-gallery.js carica dopo con defer, aspettiamo)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
